import React from "react";
import styled, { css, createGlobalStyle } from "styled-components";
import { px2rem } from "../../ezUI/StyledComponents/utils";
import Constant, { CountryIConPosition, Host } from "../../utils/constant";
import getLangKeyValueFun from "../../utils/lang";
import LangAndCur from "./components/LangAndCur";
import Country from "./components/Country";
import Search from "./components/Search";
import { AssetImageUrl } from "../../assets/imgUrl";
import { getCategories, getCartstore, getCountries, getLanguages, getCurrencies, getUserProfile, getUnPaidOrder, getInfo } from "../../services/header/header";
import langGroup from "../../assets/lang.json";
const gettext = getLangKeyValueFun(langGroup);
const GlobalStyle = createGlobalStyle `
	body.litb-m-fixscroll {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}
`;
const LitbMHeader = styled.div `
	> div {
		z-index: 3000;
	}
`;
const HeaderLayout = styled.section `
	height: ${px2rem(55)};
	border-top: 1px solid #eee;
	border-bottom: 1px solid #e2e2e2;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 ${px2rem(12)} 0 ${px2rem(2.4)};
`;
const HeaderSide = styled.section `
	width: ${px2rem(63)};
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
const HeaderIcon = styled.div `
	width: ${px2rem(30)};
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	> img {
		width: ${px2rem(24)};
	}
`;
const CartIcon = styled(HeaderIcon) `
	position: relative;
`;
const Badge = styled.div `
	position: absolute;
	top: 0.375rem;
	right: -0.375rem;
	display: block;
	z-index: 10;
	background: #e33124;
	color: #fff;
	min-width: ${px2rem(16)};
	height: ${px2rem(16)};
	text-align: center;
	line-height: ${px2rem(16)};
	padding: 0;
	font-size: ${px2rem(12)};
	font-weight: 400;
	border-radius: ${px2rem(8)};
	span {
		padding: 0 4px;
	}
`;
const Title = styled.a `
	width: ${px2rem(160)};
	height: 100%;
	position: relative;
	> img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;
const Cover = styled.div `
	position: fixed;
	top: 0;
	width: 100vw;
	height: 100%;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.4s ease;
	background: rgba(0, 0, 0, 0.6);
	> img {
		position: absolute;
		top: ${px2rem(15)};
		right: ${px2rem(50)};
		width: ${px2rem(24)};
	}
	${(props) => props.show &&
    css `
			opacity: 1;
			pointer-events: auto;
		`};
`;
const Side = styled.div `
	position: fixed;
	top: 0;
	left: -100vw;
	height: 100%;
	width: 77.3333333333vw;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background: #f5f5f5;
	transition: transform 0.4s ease;
	font-size: ${px2rem(14)};
	font-weight: normal;
	color: #333333;
	box-sizing: content-box;

	@supports (bottom: constant(safe-area-inset-bottom)) {
		padding-bottom: constant(safe-area-inset-bottom);
	}

	@supports (bottom: env(safe-area-inset-bottom)) {
		padding-bottom: env(safe-area-inset-bottom);
	}
	${(props) => props.show &&
    css `
			transform: translate3d(100vw, 0, 0);
		`};
`;
const SideItem = styled.div `
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #fff;
`;
const NextIcon = styled.img `
	height: ${px2rem(16)};
	${(props) => css `
			transform: rotate(${props.deg}deg);
		`};
`;
const LogInfo = styled.span `
	font-size: ${px2rem(16)};
	font-weight: 500;
	color: #333333;
`;
const LogSideItem = styled(SideItem) `
	height: ${px2rem(48)};
	border-bottom: 1px solid #f2f2f2;
	padding: 0 ${px2rem(12)};
	box-sizing: border-box;
`;
const MySideItem = styled(SideItem) `
	height: ${px2rem(48)};
	padding: 0 ${px2rem(12)};

	> * {
		&:first-child {
			flex: 1;
		}
	}
`;
const MyLeft = styled.div `
	display: flex;
	align-items: center;
	> img {
		height: ${px2rem(24)};
		margin-right: ${px2rem(9)};
	}
`;
const MyDot = styled.div `
	flex: 1;
	display: flex;
	justify-content: flex-end;
`;
const CategoryList = styled.div `
	margin-top: ${px2rem(9)};
	padding-bottom: ${px2rem(9)};
	background: #fff;
`;
const CategorySideItem = styled(SideItem) `
	height: ${px2rem(44)};
	box-sizing: content-box;
	padding: ${px2rem(15)} ${px2rem(12)} 0;
`;
const CategoryLeft = styled.div `
	height: 100%;
	display: flex;
	align-items: center;
`;
const GreyBg = styled.div `
	width: ${px2rem(44)};
	height: ${px2rem(44)};
	position: relative;
	margin-right: ${px2rem(6)};
	> img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
	> div {
		position: absolute;
		top: 0;
		left: 0;
		background: #000;
		opacity: 0.03;
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}
`;
const SettingSideItem = styled(SideItem) `
	height: ${px2rem(48)};
	border-bottom: 1px solid #f2f2f2;
	margin: 0 ${px2rem(12)};

	> * {
		&:first-child {
			flex: 1;
		}
	}
`;
const SettingLeft = styled.div `
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	> span:last-child {
		margin-right: ${px2rem(5)};
	}
`;
const SettingSide = styled.div `
	margin-top: ${px2rem(9)};
	background: #fff;
	${SettingSideItem}:last-child {
		border-bottom: none;
	}
`;
const CountryIcon = styled.span `
	display: inline-block;
	width: ${px2rem(24)};
	height: ${px2rem(16)};
	background-image: url(https://lijc.rightinthebox.com/jupiter_lightsource/img/icon_header_country_flag.png);
	background-repeat: no-repeat;
	background-position: 100px 100px;
`;
const FollowRight = styled.div `
	display: flex;
	align-items: center;
	height: 100%;
	> div {
		display: flex;
		align-items: center;
		height: 100%;
		padding-left: ${px2rem(9)};
	}
`;
const DownloadApp = styled.div `
	display: flex;
	align-items: center;
	margin-top: ${px2rem(9)};
	margin-bottom: ${px2rem(9)};
	width: 100%;
	height: ${px2rem(63)};
	background: url(${AssetImageUrl["bg@3x.png"]}) no-repeat;
	background-size: cover;
	> img:first-child {
		margin: 0 ${px2rem(9)} 0 ${px2rem(12)};
	}
	> img:last-child {
		margin-right: ${px2rem(20)};
	}
`;
const DownloadText = styled.div `
	flex: 1;
	> div:first-child {
		font-weight: 800;
		color: #333333;
	}
	${(props) => props.hasLowPriceCountryPriceOff && css `
			> div:last-child {
				font-weight: 500;
				color: #333333;
				> span {
					color: #e33124;
				}
			}`}
`;
const SideBody = styled.section `
	flex: auto 1;
`;
const SideBottomIcon = styled.div `
	height: ${px2rem(50)};
	flex: ${px2rem(50)} 0 0;
	width: 100%;
	padding: 0 ${px2rem(15)};
	display: flex;
	justify-content: space-between;
	border-top: 1px solid #eee;
	background-color: #fff;
	box-sizing: border-box;
	> div {
		width: ${px2rem(30)};
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}
`;
const LittleRedDot = styled.span `
	width: 9px;
	height: 9px;
	background: #ed3d28;
	border-radius: 100%;
`;
const PriceOffContainer = styled.div `
	& > span{
		color: rgb(227, 49, 36);
	}
`;
class Header extends React.Component {
    constructor(props) {
        super(props);
        this.getUser = () => {
            getUserProfile({ sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { user = 0 } = res.info || {};
                const userName = user.email ? user.email.split("@")[0] : user.user_id;
                this.setState({ userName });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getUnPaidOrder = () => {
            getUnPaidOrder({ sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined }, { onSentryCatch: this.props.onSentryCatch }).then((res) => {
                var _a;
                if (res) {
                    this.setState({ hasUnPaidOrder: !!((_a = res === null || res === void 0 ? void 0 : res.info) === null || _a === void 0 ? void 0 : _a.total_results) });
                }
            });
        };
        this.getCart = () => {
            getCartstore({
                sessionkey: Constant.sessionKey ? Constant.sessionKey : undefined
            }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { total_results = 0 } = res.info || [];
                this.setState({ total_results });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getCate = () => {
            getCategories({ feature_category_header: "YES" }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const categories = res.info || [];
                this.setState({ categories });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getCountry = () => {
            getCountries(null, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { countries = [], topCountries = [] } = res.info || {};
                const currentCountry = countries.find(item => item.countryIsoCode3 === Constant.country);
                this.setState({
                    countries,
                    topCountries,
                    currentCountry
                });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getLanguage = () => {
            getLanguages(null, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { languages = [] } = res.info || [];
                const userLanguage = languages.find(item => item.language_code === Constant.language) || {
                    language_code: "en",
                    language_name: "English"
                };
                this.setState({
                    userLanguage,
                    languages
                });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getCurrency = () => {
            getCurrencies(null, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { currencies = [], new_currencies = [] } = res.info || {};
                let currencyList = [];
                if (new_currencies && new_currencies.length > 0) {
                    currencyList = new_currencies;
                }
                else {
                    currencyList = currencies;
                }
                const userCurrency = currencyList.find(item => item.currency_code === Constant.currency) || {};
                this.setState({
                    userCurrency,
                    currencies: currencyList
                });
            })
                .catch(err => {
                console.log(err);
            });
        };
        this.getAppLowpriceCountry = () => {
            const ATTRNAME_KEY = "APP_LOWPRICE_COUNTRY";
            getInfo({ namespace: "LITB.OTHER.COUNTRIES", attrName: ATTRNAME_KEY }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { value = {} } = res.info || {};
                const keyValue = value[ATTRNAME_KEY] || "";
                if (keyValue.split(",").includes(Constant.countryId)) {
                    this.getAppLowPriceTextContent();
                }
            })
                .catch(err => {
                console.warn(err);
            });
        };
        this.getAppLowPriceTextContent = () => {
            const ATTRNAME_KEY = "app_show_banner_B_new";
            getInfo({ namespace: "LITB.APP.SERVER_B", attrName: ATTRNAME_KEY, nsLanguageCode: Constant.language }, { onSentryCatch: this.props.onSentryCatch })
                .then((res) => {
                const { value = {} } = res.info || {};
                this.setState({ lowPriceCountryPriceOff: value[ATTRNAME_KEY] || "" });
            })
                .catch(err => {
                console.warn(err);
            });
        };
        this.openSidebar = () => {
            document.body.classList.add("litb-m-fixscroll");
            this.setState({ showSidebar: true });
        };
        this.closeSidebar = () => {
            document.body.classList.remove("litb-m-fixscroll");
            this.setState({ showSidebar: false });
        };
        this.needLogin = (path) => {
            const BaseUrl = Host[String(Constant.isUat)];
            if (Constant.sessionKey && this.state.userName) {
                this.goPage(path);
                return;
            }
            window.location.href = `${BaseUrl.gmHost}/signin`;
        };
        this.stateChange = (type, value) => {
            this.setState({ [type]: value });
        };
        this.goPage = (path) => {
            window.location.href = path;
        };
        this.state = {
            userName: "",
            total_results: 0,
            showSidebar: false,
            showSearchModal: false,
            showCountryModal: false,
            countries: [],
            topCountries: [],
            currentCountry: null,
            showCurrencyModal: false,
            userCurrency: {},
            currencies: [],
            showLanguageModal: false,
            userLanguage: {
                language_code: Constant.language || "en",
                language_name: ""
            },
            languages: [],
            categories: [],
            hasUnPaidOrder: false,
            lowPriceCountryPriceOff: ""
        };
    }
    componentDidMount() {
        if (Constant.isLogin) {
            this.getUser();
        }
        this.getAppLowpriceCountry();
        this.getCart();
        this.getCate();
        this.getCountry();
        this.getLanguage();
        this.getCurrency();
        this.getUnPaidOrder();
    }
    render() {
        const { userName, total_results, showSidebar, categories, userCurrency, countries, topCountries, currentCountry, currencies, userLanguage, languages, showSearchModal, showCountryModal, showCurrencyModal, showLanguageModal, lowPriceCountryPriceOff } = this.state;
        const BaseUrl = Host[String(Constant.isUat)];
        return (React.createElement(LitbMHeader, null,
            React.createElement(GlobalStyle, null),
            React.createElement(HeaderLayout, null,
                React.createElement(HeaderSide, null,
                    React.createElement(HeaderIcon, { onClick: () => history.back() },
                        React.createElement("img", { src: AssetImageUrl["ic_back@3x.png"] })),
                    React.createElement(HeaderIcon, { onClick: this.openSidebar },
                        React.createElement("img", { src: AssetImageUrl["ic_menu@3x.png"] }))),
                React.createElement(Title, { href: "/" },
                    React.createElement("img", { src: "https://li0.rightinthebox.com/images/dfp/fs-images/2020/017ad93f7ef3d1d7d82aab1380a03c00.jpg", width: "100%" })),
                React.createElement(HeaderSide, null,
                    React.createElement(HeaderIcon, { onClick: () => this.setState({ showSearchModal: true }) },
                        React.createElement("img", { src: AssetImageUrl["ic_search@3x.png"] })),
                    React.createElement(CartIcon, { onClick: () => this.goPage(`${BaseUrl.gmHost}/${userLanguage.language_code}/cart`) },
                        React.createElement("img", { src: AssetImageUrl["tabbar_ic_cart@3x.png"] }),
                        !!total_results ? (React.createElement(Badge, null,
                            React.createElement("span", null, total_results > 999 ? "999+" : total_results))) : null))),
            React.createElement(Cover, { show: showSidebar },
                React.createElement("img", { src: AssetImageUrl["ic_closed@3x.png"], onClick: this.closeSidebar })),
            React.createElement(Side, { show: showSidebar },
                React.createElement(SideBody, { style: { overflow: "auto" } },
                    React.createElement("div", null,
                        React.createElement(LogSideItem, { onClick: () => this.needLogin(`${BaseUrl.gmHost}/${userLanguage.language_code}/account`) },
                            Constant.isLogin && userName ? (React.createElement(LogInfo, null,
                                gettext("Hi,"),
                                " ",
                                userName)) : (React.createElement(LogInfo, null,
                                gettext("Hi,"),
                                " ",
                                gettext("Sign in/Register"))),
                            React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 })),
                        React.createElement(MySideItem, { onClick: () => this.needLogin(`${BaseUrl.gmHost}/${userLanguage.language_code}/account`) },
                            React.createElement(MyLeft, null,
                                React.createElement("img", { src: AssetImageUrl["ic_My Account1@3x.png"] }),
                                React.createElement("span", null, gettext("My Account"))),
                            React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 })),
                        React.createElement(MySideItem, { onClick: () => this.needLogin(`${BaseUrl.gmHost}/${userLanguage.language_code}/orders`) },
                            React.createElement(MyLeft, null,
                                React.createElement("img", { src: AssetImageUrl["ic_My Orders@3x.png"] }),
                                React.createElement("span", null, gettext("My Orders")),
                                this.state.hasUnPaidOrder && (React.createElement(MyDot, null,
                                    React.createElement(LittleRedDot, null)))),
                            React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 })),
                        React.createElement(MySideItem, { onClick: () => this.needLogin(`${BaseUrl.gmHost}/${userLanguage.language_code}/favorites`) },
                            React.createElement(MyLeft, null,
                                React.createElement("img", { src: AssetImageUrl["ic_My Favorites@3x.png"] }),
                                React.createElement("span", null, gettext("My Favorites"))),
                            React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 })),
                        React.createElement(MySideItem, { onClick: () => this.needLogin(`${BaseUrl.gmHost}/${userLanguage.language_code}/e/help_center`) },
                            React.createElement(MyLeft, null,
                                React.createElement("img", { src: AssetImageUrl["ic_Help Center1@3x.png"] }),
                                React.createElement("span", null, gettext("Help Center"))),
                            React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 })),
                        categories && categories.length > 0 ? (React.createElement(CategoryList, null, categories.map((item, index) => {
                            return (React.createElement(CategorySideItem, { key: index, onClick: () => this.goPage(`${item.link_url}`) },
                                React.createElement(CategoryLeft, null,
                                    React.createElement(GreyBg, null,
                                        item.category_image_url ? (React.createElement("img", { src: item.category_image_url })) : null,
                                        React.createElement("div", null)),
                                    React.createElement("div", null, item.category_name)),
                                React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 })));
                        }))) : null,
                        React.createElement(SettingSide, null,
                            React.createElement(SettingSideItem, null,
                                React.createElement(SettingLeft, { onClick: () => this.setState({
                                        showCountryModal: true
                                    }) },
                                    React.createElement("span", null, gettext("Ship to")),
                                    React.createElement(CountryIcon, { style: {
                                            backgroundPosition: CountryIConPosition[currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.countryIsoCode2]
                                        } })),
                                React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 })),
                            React.createElement(SettingSideItem, { onClick: () => this.setState({
                                    showLanguageModal: true
                                }) },
                                React.createElement(SettingLeft, null,
                                    React.createElement("span", null, gettext("Language")),
                                    React.createElement("span", { style: { color: "#888" } }, userLanguage.language_text)),
                                React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 })),
                            React.createElement(SettingSideItem, { onClick: () => this.setState({
                                    showCurrencyModal: true
                                }) },
                                React.createElement(SettingLeft, null,
                                    React.createElement("span", null, gettext("Currency")),
                                    React.createElement("span", { style: { color: "#888" } },
                                        userCurrency.currency_symbol,
                                        "\u00A0",
                                        userCurrency.currency_code)),
                                React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 }))),
                        React.createElement(SettingSide, null,
                            React.createElement(SettingSideItem, { onClick: () => this.goPage(`${BaseUrl.gmHost}/${userLanguage.language_code}/about`) },
                                React.createElement("span", null, gettext("About Us")),
                                React.createElement(NextIcon, { src: AssetImageUrl["ic_next@3x.png"], deg: 0 })),
                            React.createElement(SettingSideItem, null,
                                React.createElement("span", null, gettext("Follow Us")),
                                React.createElement(FollowRight, null,
                                    React.createElement("div", null,
                                        React.createElement("iframe", { id: "facebook-iframe", src: "https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2Flightinthebox&width=41&layout=button&action=like&size=small&show_faces=true&share=false&height=65&appId", width: "50", height: "20", style: {
                                                border: "none",
                                                overflow: "hidden"
                                            }, scrolling: "no", frameBorder: "0" })),
                                    React.createElement("div", { onClick: () => this.goPage("https://api.instagram.com/oauth/authorize/?client_id=67d106c4f24f4e05af455a20c8271f42&redirect_uri=https://m.lightinthebox.com/instaback&response_type=code&scope=relationships&state=") },
                                        React.createElement("img", { src: AssetImageUrl["instagram@3x.png"], width: 20 }))))),
                        React.createElement(DownloadApp, { onClick: () => this.goPage("https://lightinthebox.onelink.me/3218718612") },
                            React.createElement("img", { src: AssetImageUrl["logo@3x.png"], width: 40 }),
                            React.createElement(DownloadText, { hasLowPriceCountryPriceOff: !!lowPriceCountryPriceOff },
                                React.createElement("div", null, "Lightinthebox"),
                                React.createElement(PriceOffContainer, { dangerouslySetInnerHTML: {
                                        __html: lowPriceCountryPriceOff ? lowPriceCountryPriceOff :
                                            `Extra <span>10% OFF</span> on APP`
                                    } })),
                            React.createElement("img", { src: AssetImageUrl["ic_download@3x.png"], width: 24 })))),
                React.createElement(SideBottomIcon, null,
                    React.createElement("div", { onClick: () => this.goPage(`${BaseUrl.mHost}/${userLanguage.language_code}`) },
                        React.createElement("img", { src: AssetImageUrl["tabbar_ic_home@3x.png"], width: "24px" })),
                    React.createElement("div", { onClick: () => this.needLogin(`${BaseUrl.gmHost}/${userLanguage.language_code}/e/help_center`) },
                        React.createElement("img", { src: AssetImageUrl["tabbar_ic_center@3x.png"], width: "24px" })),
                    React.createElement("div", { onClick: () => this.goPage(`${BaseUrl.gmHost}/${userLanguage.language_code}/cart`) },
                        React.createElement("img", { src: AssetImageUrl["tabbar_ic_cart@3x.png"], width: "24px" }),
                        !!total_results ? (React.createElement(Badge, null,
                            React.createElement("span", null, total_results))) : null),
                    React.createElement("div", { onClick: () => this.needLogin(`${BaseUrl.gmHost}/${userLanguage.language_code}/account`) },
                        React.createElement("img", { src: AssetImageUrl["tabbar_ic_account@3x.png"], width: "24px" })))),
            showSearchModal ? React.createElement(Search, { stateChange: this.stateChange, onSentryCatch: this.props.onSentryCatch }) : null,
            showCountryModal && (React.createElement(Country, { countries: countries, popularCountries: topCountries, currentCountry: currentCountry, stateChange: this.stateChange })),
            showCurrencyModal ? (React.createElement(LangAndCur, { list: currencies, title: "Currency", stateChange: this.stateChange })) : null,
            showLanguageModal ? (React.createElement(LangAndCur, { list: languages, title: "Language", stateChange: this.stateChange, onChangeLanguage: this.props.onChangeLanguage })) : null));
    }
}
export default Header;
